import AgyleButton from '../../../../../components/ui/buttons/agyleButton';
import makeStyles from '@mui/styles/makeStyles';
import {useDispatch, useSelector} from 'react-redux';
import {dischargeTemplateDict} from '../../../../../store/reducers/dicts';
import { useEffect, useRef, useState } from 'react';
import {MenuItem, Paper} from '@mui/material';
import ButtonGroup from '@mui/material/ButtonGroup';
import Popper from '@mui/material/Popper';
import Grow from '@mui/material/Grow';
import {ClickAwayListener} from '@material-ui/core';
import MenuList from '@mui/material/MenuList';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {
    ctxPatientPastActivity,
    ctxShowDischargeTemplates,
    setDischargeTemplate,
} from '../../../../../store/reducers/patientContext';

const useStyles = makeStyles((theme) => {
    return {
        dischargeButton: {
            '&:hover': {
                color: 'white',
            },
        },
        container: {
            boxShadow: 'none',
        },
        menuButton: {
            backgroundColor: theme.palette.primary.main,
        },
        menu: {
            backgroundColor: theme.palette.inPatient.inputBackground,
            borderRadius: 10,
            boxShadow: `1px 1px 12px 0px rgba(0, 0, 0, 0.15)`,
        },
    };
});

const MainScreenDischargeButton = ({button}) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    // Selectors
    const templates = useSelector(dischargeTemplateDict);
    const pastActivity = useSelector(ctxPatientPastActivity);
    const isShowDischargeTemplates = useSelector(ctxShowDischargeTemplates);
    const isReadyToTransfer = button.isReadyToTransfer;

    // State for a menu
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    const handleMenuItemClick = (template) => {
        setOpen(false);

        dispatch(setDischargeTemplate(template));
        button.event(template);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    useEffect(() => {
        if (isShowDischargeTemplates) {
            if (!pastActivity && !isReadyToTransfer && templates?.length > 0) {
                handleToggle();
            } else {
                button.event(null);
            }
        }
    }, [isShowDischargeTemplates, pastActivity, isReadyToTransfer, templates?.length])

    return (
        <>
            <ButtonGroup
                variant="contained"
                ref={anchorRef}
                className={classes.container}
            >
                <AgyleButton
                    className={classes.dischargeButton}
                    key={button.name}
                    startIcon={button.icon}
                    variant={button?.buttonVariant}
                    disabled={button.disabled || false}
                    color={button.color}
                    onClick={() => button.event(null)}
                    style={{
                        width: 'auto',
                        margin: 0,
                        paddingTop: 5,
                    }}
                >
                    {button.display}
                </AgyleButton>

                {!pastActivity && !isReadyToTransfer && templates?.length > 0 &&
                    <AgyleButton
                        aria-controls={open ? 'split-button-menu' : undefined}
                        aria-expanded={open ? 'true' : undefined}
                        aria-label="select dischare template"
                        aria-haspopup="menu"
                        onClick={handleToggle}
                        color={button.color}
                        variant={button?.buttonVariant}
                        style={{
                            width: 20,
                            margin: 0,
                            paddingTop: 5,
                            display: 'flex',
                            alignItems: 'flex-start',
                        }}
                    >
                        <ArrowDropDownIcon/>
                    </AgyleButton>
                }
            </ButtonGroup>

            <Popper
                sx={{zIndex: 1}}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
            >
                {({TransitionProps, placement}) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === 'bottom' ? 'center top' : 'center bottom',
                        }}
                    >
                        <Paper  className={classes.menu}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList autoFocusItem>
                                    {templates.map((option) => (
                                        <MenuItem
                                            key={option?.__id}
                                            onClick={() => handleMenuItemClick(option)}
                                            style={{height: 25}}
                                        >
                                            {option?.description}
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    );
};

export default MainScreenDischargeButton;